import { IAction } from "../../configs/types";
import { IUserState } from "./userReducer";

export enum EUserActionTypes {
  "SignIn" = "SIGN_IN",
  "SignOut" = "SIGN_OUT",
  "SetNotification" = "SET_NOTIFICATION",
};

export const userActionSignIn = (userData: IUserState): IAction<EUserActionTypes, IUserState> => ({
  type: EUserActionTypes.SignIn,
  payload: userData
});

export const userActionSignOut = (): IAction<EUserActionTypes> => ({
  type: EUserActionTypes.SignOut,
});

export const userActionSetNotification = (notification: { message: string; type: 'success' | 'error' } | null): IAction<EUserActionTypes, any> => ({
  type: EUserActionTypes.SetNotification,
  payload: notification
});